export const ORDER_SEGMENTS = Object.freeze({
  ALL: 'all',
  ATTENTION: 'attention',
  UNPAID: 'unpaid',
  PAID: 'paid',
});

export function getOrderAttentionReason(order) {
  if (!order || order.isCanceled || order.isRefunded) return null;
  if (order.attentionReason) return order.attentionReason;
  if (order.status === 'payment-pending') return 'payment-pending';

  const product = order.product || order.Product;
  if (!order.isPaid || !product) return null;

  if (
    (product.type === 'physical' || product.type === 'commission')
    && !order.shippedAt
  ) {
    return 'shipping';
  }

  if (product.type === 'custom' && !order.customFileId) {
    return 'custom-file';
  }

  return null;
}

export function orderMatchesSegment(order, segment) {
  switch (segment) {
    case ORDER_SEGMENTS.ATTENTION:
      return Boolean(getOrderAttentionReason(order));
    case ORDER_SEGMENTS.UNPAID:
      return !order.isPurchased;
    case ORDER_SEGMENTS.PAID:
      return Boolean(order.isPurchased);
    case ORDER_SEGMENTS.ALL:
    default:
      return true;
  }
}

export function filterOrders(orders = [], segment = ORDER_SEGMENTS.ALL) {
  return orders.filter(order => orderMatchesSegment(order, segment));
}

export function getAttentionLabel(order) {
  switch (getOrderAttentionReason(order)) {
    case 'payment-pending':
      return 'Payment Settling';
    case 'shipping':
      return 'Needs Shipping';
    case 'custom-file':
      return 'Needs Custom File';
    default:
      return 'View Order';
  }
}

/**
 * Server-computed flag (`toSellerOrderApi`): processor-billed orders
 * (Authorize.net, PayPal, CCBill) are completed by their processor flow and
 * must not be marked as paid manually. Absent flag (older payloads) keeps the
 * button; the markpaid route re-checks and rejects.
 */
export function canManuallyMarkPaid(order) {
  return Boolean(order) && order.canManuallyMarkPaid !== false;
}
